const $ = window.jQuery;

(function($) {
	
	let table = $('.main-table-wrapper'), tableLoaded=false, loadingTable = false, scrolling = false;

	function doScrolling() {
        if (!loadingTable && !tableLoaded ) {
            loadingTable = true;
            !tableLoaded && import(/* webpackChunkName: "tc-inner" */'./tc-inner')
                .then(() => {
                    loadingTable = false;
                    tableLoaded = true;
                });
		}
	}

    window.scrollingTasks.push(doScrolling);


 

})(window.jQuery);